import cookie from './cookie';

export default ({d, ...param}) => new Promise((resolve) => {
    const finalParam = {
        v: 1,
        action: 1002,
        time: new Date().getTime(),
        ...param,
        d: encodeURIComponent(JSON.stringify({
            ppu: cookie.get('PPU'),
            ...d
        }))
    };
    let imgEl = new Image();
    imgEl.onload = () => {
        resolve();
        imgEl = null;
    };
    imgEl.onerror = () => {
        resolve();
        imgEl = null;
    };
    imgEl.src = `//luna.58.com/track?${Object.keys(finalParam).map((k) => `${k}=${finalParam[k]}`)
        .join('&')}`;

});
